export default "__VITE_ASSET__BLP4lRFW__"